/* eslint-disable */
// src/utils/localMachineOrder.js

import { hasRent } from "utils/rent";

const FIXED_TYPE_ORDER = ["Tragamoneda", "Pool", "Rockola", "Tejo", "Peluchera"];
const TYPE_RANK = new Map(FIXED_TYPE_ORDER.map((type, idx) => [type, idx]));

const normalize = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const canonicalType = (rawType) => {
  const n = normalize(rawType);
  if (!n) return "No asignado";
  if (n === "tragamonedas" || n === "tragamoneda") return "Tragamoneda";
  if (n === "pool") return "Pool";
  if (n === "rockola") return "Rockola";
  if (n === "tejo") return "Tejo";
  if (n === "peluchera") return "Peluchera";
  return String(rawType).trim() || "No asignado";
};

export const getMachineTypeName = (machine) => {
  const rawType =
    machine?.MachineType?.Type ??
    machine?.MachineType ??
    machine?.Machine?.MachineType?.Type ??
    machine?.Machine?.MachineType ??
    "No asignado";

  return canonicalType(rawType);
};

export const getLocalMachineId = (machine) => {
  const rawId =
    machine?.LocalMachineId ??
    machine?.Id ??
    machine?.LocalMachine?.Id ??
    Number.MAX_SAFE_INTEGER;

  const num = Number(rawId);
  return Number.isFinite(num) ? num : Number.MAX_SAFE_INTEGER;
};

export const getLocalMachineSerial = (machine) => {
  const rawSerial =
    machine?.SerialNumber ??
    machine?.Machine?.SerialNumber ??
    machine?.LocalMachine?.SerialNumber ??
    "";

  return String(rawSerial ?? "").trim();
};

export const getLocalDisplayNumber = (machine) => {
  const raw =
    machine?.LocalDisplayNumber ??
    machine?.Machine?.LocalDisplayNumber ??
    machine?.LocalMachine?.LocalDisplayNumber ??
    null;
  if (raw === null || raw === undefined || raw === "") return null;
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : null;
};

export const compareMachineTypeOrder = (typeA, typeB) => {
  const a = canonicalType(typeA);
  const b = canonicalType(typeB);
  const ra = TYPE_RANK.has(a) ? TYPE_RANK.get(a) : Number.MAX_SAFE_INTEGER;
  const rb = TYPE_RANK.has(b) ? TYPE_RANK.get(b) : Number.MAX_SAFE_INTEGER;

  if (ra !== rb) return ra - rb;
  return a.localeCompare(b, "es", { sensitivity: "base" });
};

export const sortLocalMachinesFixed = (items = [], options = {}) =>
  [...(items || [])].sort((a, b) => {
    if (options.preferLocalDisplayNumber) {
      const displayA = getLocalDisplayNumber(a);
      const displayB = getLocalDisplayNumber(b);
      const hasDisplayA = displayA != null;
      const hasDisplayB = displayB != null;

      if (hasDisplayA || hasDisplayB) {
        if (hasDisplayA !== hasDisplayB) return hasDisplayA ? -1 : 1;
        if (displayA !== displayB) return displayA - displayB;
      }
    }

    const rentedDelta = Number(hasRent(a)) - Number(hasRent(b));
    if (rentedDelta !== 0) return rentedDelta;

    const typeDelta = compareMachineTypeOrder(getMachineTypeName(a), getMachineTypeName(b));
    if (typeDelta !== 0) return typeDelta;

    const serialA = getLocalMachineSerial(a);
    const serialB = getLocalMachineSerial(b);
    const hasSerialA = serialA.length > 0;
    const hasSerialB = serialB.length > 0;

    if (hasSerialA || hasSerialB) {
      if (hasSerialA !== hasSerialB) return hasSerialA ? -1 : 1;
      const serialDelta = serialA.localeCompare(serialB, "es", {
        sensitivity: "base",
        numeric: true,
      });
      if (serialDelta !== 0) return serialDelta;
    }

    const nameA = String(a?.Machine?.Name ?? a?.MachineName ?? a?.Name ?? "");
    const nameB = String(b?.Machine?.Name ?? b?.MachineName ?? b?.Name ?? "");
    const nameDelta = nameA.localeCompare(nameB, "es", { sensitivity: "base" });
    if (nameDelta !== 0) return nameDelta;

    const idDelta = getLocalMachineId(a) - getLocalMachineId(b);
    return idDelta;
  });

export const sortTypeEntries = (groups = {}) =>
  Object.entries(groups || {}).sort(([a], [b]) => compareMachineTypeOrder(a, b));
